import { getRouteApi } from '@tanstack/react-router';

import { OAuthInstallCallback } from '~/components/connections/OAuthInstallCallback';

const routeApi = getRouteApi('/oauth/discord/callback');

export function DiscordOAuthCallbackPage() {
  const { connectionId, topicId, error, message } = routeApi.useSearch();

  return (
    <OAuthInstallCallback
      provider="Discord"
      connectionId={connectionId}
      topicId={topicId}
      errorCode={error}
      errorMessage={message}
      errors={{
        access_denied: {
          title: 'Discord installation cancelled',
          details: 'You declined to install the DeadDrop bot in your Discord server.',
        },
        oauth_failed: {
          title: 'Discord connection failed',
          details: message || 'Failed to complete Discord OAuth flow.',
        },
      }}
    />
  );
}
